/**
 * Centralized color tokens — COLOR ONLY.
 * Source palette for the application theme.
 */

export const colors = {
  canvas: '#f7f8fa',
  surface: '#ffffff',
  surfaceHover: '#f5f6f8',
  text: '#323338',
  textMuted: '#676879',
  placeholder: '#c5c7d0',
  border: '#e6e9ef',
  borderStrong: '#d0d4dc',
  primary: '#00a86a',
  primaryHover: '#037f4c',
  primaryText: '#ffffff',
  accent: '#0073ea',
  accentHover: '#0060c2',
  focus: '#0073ea',
  link: '#0073ea',
  success: '#00c875',
  warning: '#fdab3d',
  danger: '#e44258',
  dangerHover: '#c9364a',
  info: '#0073ea',
  hoverBg: '#f5f6f8',
  selectedBg: '#e5f4ff',
  brandBlue: '#1a335b',
  brandGold: '#b79961',
  brandGoldHover: '#a68955',
  shadow: '50, 51, 56',
};

export default colors;
